<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <v-form ref="resetPassForm">
          <v-text-field
            :append-icon="visibility.currPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="visibility.currPassword ? 'text' : 'password'"
            @click:append="visibility.currPassword = !visibility.currPassword"
            v-model="currPassword"
            label="Current Password"
            :rules="validators.currPassword"
            outlined
          ></v-text-field>
          <v-text-field
            :append-icon="visibility.newPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="visibility.newPassword ? 'text' : 'password'"
            @click:append="visibility.newPassword = !visibility.newPassword"
            v-model="newPassword"
            label="New Password"
            :rules="validators.newPassword"
            outlined
          ></v-text-field>
          <v-text-field
            :append-icon="visibility.newPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="visibility.newPassword ? 'text' : 'password'"
            @click:append="visibility.newPassword = !visibility.newPassword"
            label="Confirm New Password"
            :rules="validators.confirmPassword"
            outlined
          ></v-text-field>
          <v-btn
            class="btn btn-primary"
            @click="updatePassword"
          >{{submitting?"Saveing..":"Update Password"}}</v-btn>
        </v-form>

        <v-snackbar v-model="message.visible" :color="message.type" :timeout="message.duration" top>
          {{message.body}}
          <v-btn dark text @click="message.visible = false">Close</v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { isPassword } from "../../../helpers/validators";
import MessagingMixin from "../../../mixins/messaging";

export default {
  mixins: [MessagingMixin],
  data() {
    return {
      currPassword: "",
      newPassword: "",
      visibility: {
        currPassword: false,
        newPassword: false
      },
      submitting: false,
      validators: {
        currPassword: [val => isPassword(val) || "Please Enter valid password"],
        newPassword: [val => isPassword(val) || "Please Enter valid password"],
        confirmPassword: [
          val => !val || val === this.newPassword || "Password does not match."
        ]
      }
    };
  },
  watch: {
    newPassword: "validateForm"
  },
  methods: {
    validateForm() {
      return this.$refs.resetPassForm.validate();
    },
    updatePassword() {
      let formValid = this.validateForm();
      if (!formValid) return;
      this.submitting = true;
      this.$store
        .dispatch("user/updateUserPassword", {
          currPassword: this.currPassword,
          newPassword: this.newPassword
        })
        .then(() => {
          this.submitting = false;
          this.setMessage("Password updated successfully", "success");
        })
        .catch(error => {
          this.submitting = false;
          this.setMessage(error.message, "error");
        });
    }
  }
};
</script>

<style>
</style>